import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';

import {
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eb/site-analytics';

import {
    GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
    GA_ACCOUNT_LINK_FAILED,
    GA_ACCOUNT_LINKED,
    GA_ACCOUNT_LOGIN_NOT_LINKED,
    GA_APPLE_LOGIN_ACCOUNT_CREATED,
    GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT,
    GA_APPLE,
    GA_AUTH_CATEGORY,
    GA_AUTH_CHECKOUT_CATEGORY,
    GA_CHECK_EMAIL_PROMPT_EVENT,
    GA_COMMUNITY_GUIDELINES_CLICKED,
    GA_COMUNITY_GUIDELINES_CLICKED as OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    GA_CONFIRM_EMAIL_SHOWED,
    GA_CONFIRMATION_ACKNOWLEDGED,
    GA_CONFIRMATION_REJECTED,
    GA_CONTINUE_CREATE_ACCOUNT_CLICKED,
    GA_CONTINUE_CREATE_ACCOUNT_EXISTS,
    GA_CONTINUE_CREATE_ACCOUNT_NEW,
    GA_EDIT_EMAIL_EVENT,
    GA_EDIT_EMAIL_MISMATCH,
    GA_EMAIL_NOT_FOUND,
    GA_ENTER_EMAIL_EVENT,
    GA_EVENTBRITE,
    GA_EXISTING_ACCT_LABEL,
    GA_FACEBOOK,
    GA_FB_LOGIN_ACCOUNT_CREATED,
    GA_FB_LOGIN_BUTTON_CLICKED_EVENT,
    GA_FB_LOGIN_EMAIL_ALREADY_EXISTS_ON_SOFT_ACCOUNT,
    GA_FB_LOGIN_EMAIL_NOT_SHARED,
    GA_FB_LOGIN_EXTERNAL_USER_UNKNOWN,
    GA_FB_LOGIN_LOGGED_IN_TO_FB,
    GA_FB_LOGIN_NO_EMAIL_ADDRESS,
    GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB,
    GA_FB_LOGIN_PERMISSIONS_GRANTED,
    GA_FB_LOGIN_PERMISSIONS_NOT_GRANTED,
    GA_FORGOT_PASSWORD_EVENT,
    GA_GET_STARTED_CLICKED,
    GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_FB,
    GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE,
    GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB,
    GA_HIDDEN_EMAIL,
    GA_LINK_ACCOUNT_OPTION,
    GA_LINK_ACCOUNTS_LOGIN_EVENT,
    GA_LOGIN_CATEGORY,
    GA_LOGIN_CLICKED,
    GA_LOGIN_EVENT,
    GA_LOGIN_INSTEAD_CLICKED_EVENT,
    GA_LOGIN_INVALID_EMAIL,
    GA_LOGIN_INVALID_PASSWORD,
    GA_LOGIN_SUCCESSFUL,
    GA_LOGIN_SUCCESSONESTEP,
    GA_MAGIC_LINK_CLICKED,
    GA_MAGIC_LINK_CONFIRMATION_CLOSED,
    GA_MAGIC_LINK_FAILED,
    GA_MAGIC_LINK_SENT,
    GA_NEW_ACCT_LABEL,
    GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
    GA_PASSWORD_FORGOTTEN_MAIL_SENT,
    GA_PASSWORD_FORGOTTEN,
    GA_PASSWORD_INCORRECT,
    GA_PASSWORD_VIEWED,
    GA_PRIVACY_POLICY_CLICKED_OLD,
    GA_PRIVACY_POLICY_CLICKED,
    GA_RE_ENTER_EMAIL_LABEL,
    GA_SESSION_EXPIRED,
    GA_SHOWED_EMAIL,
    GA_SIGNUP_CLICKED,
    GA_SIGNUP_EVENT,
    GA_SIWA_ACCOUNT_CREATED_FAILED,
    GA_SIWA_ACCOUNT_CREATED,
    GA_SIWA_ACCOUNTS_LINK_OPTION,
    GA_SIWA_EMAIL_ALREADY_EXISTS,
    GA_SIWA_POPUP_CLOSED,
    GA_SOCIAL_LOGIN_ACCOUNT_LINKING_FAILED,
    GA_SOCIAL_LOGIN_EMAIL_ALREADY_EXISTS,
    GA_SOCIAL_SIGNUP_EVENT,
    GA_SOCIAL_SOFT_ACCOUNT_EXISTS,
    GA_SOFT_ACCOUNT_MAIL_FAILED,
    GA_SOFT_ACCOUNT_MAIL_SENT,
    GA_SOFT_ACCT_LABEL,
    GA_TERMS_OF_SERVICE_CLICKED,
    GA_TERMS_OF_SERVICE_CLICKED_OLD,
    GA_TOKEN_EXPIRED,
    GA_USE_ANOTHER_ACCOUNT_CLICKED,
    GA_ACCOUNT_AUTOLINKED,
} from '../constants/analytics';

// Used to capitalize labels once a tracking is triggered
export const capitalize = (string) => {
    if (!isUndefined(string)) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
        return string;
    }
};
// SIWA flow metrics

/****************************
 * User doesn't share email *
 ****************************/

// User has an EB account
export const trackSIWA_LookUpSuccessWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_HIDDEN_EMAIL,
    });
};

// User has an EB account, enters wrong password
export const trackSIWA_WrongPassword = (state) => {
    trackEventFromState(state, {
        action: GA_LOGIN_INVALID_PASSWORD,
        category: GA_AUTH_CATEGORY,
        label: capitalize(GA_APPLE),
    });
};

// User doesn't has an EB account, enters an email that isn't an EB account
export const trackSIWA_EmailNotFound = (state) => {
    trackEventFromState(state, {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_EMAIL_NOT_FOUND,
    });
};

// track accounts linked when user hide the email but add EB account on page load
export const trackSIWA_AccountsLinkOptionWithHiddenEmail = (hidden) => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNTS_LINK_OPTION,
        category: GA_AUTH_CATEGORY,
        label: hidden ? GA_HIDDEN_EMAIL : GA_SHOWED_EMAIL,
    });
};

// track account created when user hide his email and doesn't have an EB account
export const trackSIWA_AccountCreatedWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_ACCOUNT_CREATED,
        category: GA_AUTH_CATEGORY,
        label: capitalize(GA_APPLE),
    });
};

// track when user wants to link his account with an EB account
export const trackSIWA_AccountLinkAttemptWithHiddenEmail = () => (
    dispatch,
    getState,
) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_LINK_ACCOUNT_OPTION,
    });
};

/****************************
 *     User share email     *
 ****************************/

// track successfuly login with showed email
export const trackSIWA_LookUpSuccessWithEmail = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_SIWA_EMAIL_ALREADY_EXISTS,
        category: GA_AUTH_CATEGORY,
        label: GA_SHOWED_EMAIL,
    });
};

/*
 * User enter wrong password for his EB account
 */
// export const trackSIWA_WrongPasswordWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LOGIN_INVALID_PASSWORD,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User successfuly link their account
 */
// export const trackSIWA_LinkAccountWithEBAccount = (sourceProvider) => (
//     dispatch,
//     getState,
// ) => {
//     trackEventFromState(getState(), {
//         action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
//         category: GA_AUTH_CATEGORY,
//         label: sourceProvider,
//     });
// };

/*
 * User enter an email that isn't an EB account
 */
// export const trackSIWAEmailNotFound = () => (dispatch, getState) => {
//     trackEventFromState(getState(), {
//         action: GA_SIWA_EMAIL_ALREADY_EXISTS,
//         category: GA_AUTH_CATEGORY,
//         label: GA_EMAIL_NOT_FOUND,
//     });
// };

export const trackSIWA_errorOnNewUser = (state, label) => {
    trackEventFromState(state, {
        action: GA_SIWA_ACCOUNT_CREATED_FAILED,
        category: GA_AUTH_CATEGORY,
        label,
    });
};

/****************************
 *     General cases     *
 ****************************/

// Track when token expired
export const trackTokenExpired = ({ sourceProvider, state, path = '' }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_TOKEN_EXPIRED + path,
        label:
            !isUndefined(sourceProvider) && sourceProvider !== 'None'
                ? capitalize(sourceProvider)
                : GA_EVENTBRITE,
    });
};

// Track when session has expired
export const trackSessionExpired = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SESSION_EXPIRED,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};
/****************************************
 * *GA TRACKING FOR LOGIN VERSION 2.X.X *
 ****************************************/

export const trackLoginClicked = ({
    sourceProvider,
    stateFromProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    let action = '';
    let actionFB = '';
    if (isUndefined(sourceProvider)) {
        action = GA_GET_STARTED_CLICKED;
    } else if (sourceProvider === GA_EVENTBRITE) {
        action = GA_LOGIN_CLICKED;
    } else if (sourceProvider === GA_FACEBOOK) {
        action = GA_FB_LOGIN_BUTTON_CLICKED_EVENT;
        actionFB = GA_FB_LOGIN_LOGGED_IN_TO_FB;
        if (stateFromProvider && stateFromProvider.status === 'unknown') {
            actionFB = GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB;
        }
    } else if (sourceProvider === GA_APPLE) {
        action = GA_APPLE_LOGIN_BUTTON_CLICKED_EVENT;
    }

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor ? GA_LOGIN_CLICKED : action,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
    //If it's FB Flow, then we throw specific metrics
    if (!isEmpty(actionFB)) {
        trackEventFromState(state, {
            category: launchAuthenticationRefactor
                ? GA_LOGIN_CATEGORY
                : GA_AUTH_CATEGORY,
            action: actionFB,
            label: capitalize(GA_FACEBOOK),
        });
    }
};

export const trackSignUpClicked = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SIGNUP_CLICKED,
    });
};

export const OLD_trackLoginInsteadClick = () => (dispatch, getState) => {
    const state = getState();

    trackLoginInsteadClick({ state });
};

export const trackLoginInsteadClick = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_INSTEAD_CLICKED_EVENT,
    });
};

export const trackLoginSuccessful = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_SUCCESSFUL,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackLoginSuccessOneStep = ({
    sourceProvider,
    state,
    gaCategory,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: !isUndefined(gaCategory)
            ? gaCategory
            : launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LOGIN_SUCCESSONESTEP,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackEmailIncorrect = ({
    gaActionCategory,
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : gaActionCategory,
        action: GA_LOGIN_INVALID_EMAIL,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordIncorrect = ({
    gaActionCategory,
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : gaActionCategory,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_INCORRECT
            : GA_LOGIN_INVALID_PASSWORD,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordViewed = ({ sourceProvider, state }) => {
    trackEventFromState(state, {
        category: GA_LOGIN_CATEGORY,
        action: GA_PASSWORD_VIEWED,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordForgotten = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PASSWORD_FORGOTTEN
            : GA_FORGOT_PASSWORD_EVENT,
        label: capitalize(sourceProvider),
    });
};

export const trackPasswordForgottenMailFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_FAILED,
        label: errorMessage,
    });
};
export const trackPasswordForgottenMailSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_PASSWORD_FORGOTTEN_MAIL_SENT,
        label: capitalize(sourceProvider),
    });
};

export const trackPasswordReseted = ({
    sourceProvider,
    state,
    setPasswordEvent,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: setPasswordEvent,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackPasswordResetedFailed = ({
    errorMessage,
    state,
    setPasswordEvent,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: `${setPasswordEvent}Failed`,
        label: errorMessage,
    });
};

export const trackCommunityGuidelinesClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_COMMUNITY_GUIDELINES_CLICKED
            : OLD_GA_COMUNITY_GUIDELINES_CLICKED,
    });
};

export const trackPrivacyPolicyClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_PRIVACY_POLICY_CLICKED
            : GA_PRIVACY_POLICY_CLICKED_OLD,
    });
};

export const trackTermsOfServiceClicked = () => (dispatch, getState) => {
    const state = getState();
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_TERMS_OF_SERVICE_CLICKED
            : GA_TERMS_OF_SERVICE_CLICKED_OLD,
    });
};

export const trackUseAnotherAccountClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: launchAuthenticationRefactor
            ? GA_USE_ANOTHER_ACCOUNT_CLICKED
            : GA_EDIT_EMAIL_EVENT,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};

export const trackMagicLinkClicked = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CLICKED,
        label: capitalize(sourceProvider),
    });
};

export const trackContinueCreateAccountClick = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_CONTINUE_CREATE_ACCOUNT_CLICKED,
        label: capitalize(sourceProvider),
    });
};

export const trackContinueCreateAccountExists = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_CONTINUE_CREATE_ACCOUNT_EXISTS,
        label: capitalize(sourceProvider),
    });
};

export const trackContinueCreateAccountNew = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_CONTINUE_CREATE_ACCOUNT_NEW,
        label: capitalize(sourceProvider),
    });
};

export const trackMagicLinkSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_SENT,
        label: capitalize(sourceProvider),
    });
};

export const trackMagicLinkFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_FAILED,
        label: errorMessage,
    });
};

export const trackMagicLinkConfirmationClosed = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_MAGIC_LINK_CONFIRMATION_CLOSED,
        label: capitalize(sourceProvider),
    });
};

export const trackAccountLinked = ({
    sourceProvider,
    state,
    linked = true,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: linked ? GA_ACCOUNT_LINKED : GA_ACCOUNT_LOGIN_NOT_LINKED,
        label: capitalize(sourceProvider),
    });
};

export const trackAccountLinkFailed = ({ errorDescription, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_FAILED,
        label: errorDescription,
    });
};

export const trackAccountLinkConfirmationClosed = ({ label, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_LINK_CONFIRMATION_CLOSED,
        label,
    });
};

export const trackSocialEmailAlreadyExists = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_LOGIN_EMAIL_ALREADY_EXISTS,
        label: capitalize(sourceProvider),
    });
};

export const trackSocialSoftAccountExists = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_SOFT_ACCOUNT_EXISTS,
        label: capitalize(sourceProvider),
    });
};

// User has an EB account, successfuly link their account
export const trackSuccessfullyLinkAccountsWithExistingEBAccount = ({
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_LINK_ACCOUNTS_LOGIN_EVENT,
        label: capitalize(sourceProvider),
    });
};

//Error on linking accounts
export const trackErrorOnLinkAccountsWithExistingEBAccount = ({
    errorDescription,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromStateOnPageUnload(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOCIAL_LOGIN_ACCOUNT_LINKING_FAILED,
        label: errorDescription,
    });
};

//Account connected with FB without pass
export const trackAccountAlreadyConnectedWithFB = ({
    sourceProvider,
    state,
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_FB,
        label: !isUndefined(sourceProvider)
            ? capitalize(sourceProvider)
            : GA_EVENTBRITE,
    });
};
export const trackSoftAccountMailFailed = ({ errorMessage, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOFT_ACCOUNT_MAIL_FAILED,
        label: errorMessage,
    });
};
export const trackSoftAccountMailSent = ({ sourceProvider, state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_SOFT_ACCOUNT_MAIL_SENT,
        label: capitalize(sourceProvider),
    });
};

export const trackEnterEmailSoftAccount = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_SOFT_ACCT_LABEL,
    });
};

export const trackEnterEmailExistingAccount = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_EXISTING_ACCT_LABEL,
    });
};

export const trackEnterEmailNewAccount = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_NEW_ACCT_LABEL,
    });
};

export const trackAccountConnectedToFacebookAndApple = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE_FB,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackAccountConnectedToApple = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_GET_STARTED_EMAIL_ALREADY_CONNECTED_TO_APPLE,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBAccountCreated = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_ACCOUNT_CREATED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBPermissionNotGranted = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_PERMISSIONS_NOT_GRANTED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBPermissionGranted = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_PERMISSIONS_GRANTED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackSIWAPopUpClosed = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_SIWA_POPUP_CLOSED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackSocialSignupEvent = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        action: GA_SOCIAL_SIGNUP_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackCheckoutEnterEmailExistingAccount = ({ state }) => {
    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: GA_AUTH_CHECKOUT_CATEGORY,
        label: GA_EXISTING_ACCT_LABEL,
    });
};

export const trackCheckoutEnterEmailSoftAccount = ({ state }) => {
    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: GA_AUTH_CHECKOUT_CATEGORY,
        label: GA_SOFT_ACCT_LABEL,
    });
};

export const trackCheckoutEnterEmailNewAccount = ({ state }) => {
    trackEventFromState(state, {
        action: GA_ENTER_EMAIL_EVENT,
        category: GA_AUTH_CHECKOUT_CATEGORY,
        label: GA_NEW_ACCT_LABEL,
    });
};

export const trackAppleNewAccount = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_APPLE_LOGIN_ACCOUNT_CREATED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackSignInConfirmationAcknowledged = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_CONFIRMATION_ACKNOWLEDGED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackSignInConfirmationRejected = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_CONFIRMATION_REJECTED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBEmailAlreadyExistOnSoftAccount = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_EMAIL_ALREADY_EXISTS_ON_SOFT_ACCOUNT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBLoginNoEmailAddress = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_NO_EMAIL_ADDRESS,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBLoginEmailNotShared = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_EMAIL_NOT_SHARED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBLoginExternalUserUnknown = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_FB_LOGIN_EXTERNAL_USER_UNKNOWN,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackCheckEmailPrompt = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_CHECK_EMAIL_PROMPT_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_SOFT_ACCT_LABEL,
    });
};

export const trackEditEmailEventCheckout = ({ state, sourceProvider }) => {
    trackEventFromState(state, {
        action: GA_EDIT_EMAIL_EVENT,
        category: GA_AUTH_CHECKOUT_CATEGORY,
        label: sourceProvider,
    });
};

export const trackLoginEventCheckout = ({ state }) => {
    trackEventFromStateOnPageUnload(state, {
        action: GA_LOGIN_EVENT,
        category: GA_AUTH_CHECKOUT_CATEGORY,
    });
};

export const trackSignupEvent = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromStateOnPageUnload(state, {
        action: GA_SIGNUP_EVENT,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_EVENTBRITE,
    });
};

export const trackConfirmEmailShowed = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_CONFIRM_EMAIL_SHOWED,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        label: GA_RE_ENTER_EMAIL_LABEL,
    });
};

export const trackEditEmailMismatch = ({ state }) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;

    trackEventFromState(state, {
        action: GA_EDIT_EMAIL_MISMATCH,
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
    });
};

export const trackFBLoginNotLoggedInCheckout = ({ state }) => {
    trackEventFromState(state, {
        action: GA_FB_LOGIN_NOT_LOGGED_IN_TO_FB,
        category: GA_AUTH_CHECKOUT_CATEGORY,
    });
};

export const trackFBLoginSuccess = (state, response, actionCategory) => {
    if (response['new_user']) {
        trackFBAccountCreated({ state });
        trackLoginSuccessful({
            sourceProvider: GA_FACEBOOK,
            state,
        });
    } else {
        trackLoginSuccessOneStep({
            sourceProvider: GA_FACEBOOK,
            state,
            gaCategory: actionCategory,
        });
    }
};

export const trackAccountAutolinked = ({
    state,
    sourceProvider,
    extraInfo = '',
}) => {
    const launchAuthenticationRefactor =
        state.authentication.featureFlags.launchAuthenticationRefactor;
    trackEventFromState(state, {
        category: launchAuthenticationRefactor
            ? GA_LOGIN_CATEGORY
            : GA_AUTH_CATEGORY,
        action: GA_ACCOUNT_AUTOLINKED + extraInfo,
        label: capitalize(sourceProvider),
    });
};
/** END GA TRACKING FOR LOGIN VERSION 2.X.X */
